// exports SecurableType - an immutable object 'enum'
// usage: import { SecurableType } from '../../enums/SecurableTypes';
const securableTypes = {
    MRRLandingPageTab: 1,
    MRRProject: 2,
    Reports: 3,
    MRRApplication: 4
};
Object.freeze(securableTypes);
export const SecurableType = securableTypes;